import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { IonicVue } from '@ionic/vue';
import App from './App.vue';
import router from './router';

/* Ionic core CSS */
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* SwipeWish theme (dark + viola) */
import './theme/variables.css';
import './theme/common.css';

// Bootstrap registers the auth listener and reads the cached session from
// localStorage synchronously. Profile and plan load in the background.
(async () => {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);
  app.use(IonicVue, { mode: 'md' });

  const { useUserStore } = await import('./stores/useUserStore');
  try {
    await useUserStore().init({ blockingUserData: false });
  } catch (e) {
    console.error('[bootstrap user init]', e);
  }

  app.use(router);
  await router.isReady();
  app.mount('#app');
})();
